import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './PikPlusSubway.css';
import { UndergroundIcon } from '../UndergroundIcon';
import { EMovingType } from '../../constants/pikPlus';

interface IPikPlusSubwayProps {
  title?: string | null;
  lineColor?: string | null;
  timeDisplay?: string | null;
  movingType: EMovingType | null;
  regionId: number | null;
}

export function PikPlusSubway({ title, lineColor, regionId, movingType, timeDisplay }: IPikPlusSubwayProps) {
  return (
    <div className={styles['container']} data-testid="pik_plus_subway">
      <span className={styles['subway']}>
        {lineColor && <UndergroundIcon regionId={regionId} lineColor={lineColor} />}
        {title && <span className={styles['title']}>{title}</span>}
      </span>
      {timeDisplay && (
        <div className={styles['subway-from']}>
          {movingType && movingType === EMovingType.Walk ? (
            <IconMapWalk16 color="icon-inverted-default" />
          ) : (
            <IconMapCar16 color="icon-inverted-default" data-testid="subway_icon_car" />
          )}
          <div className={styles['time']}>
            <UIText2 color="text-inverted-default">{timeDisplay}</UIText2>
          </div>
        </div>
      )}
    </div>
  );
}
